import PieChart from './component'

export default PieChart
